export default "__VITE_ASSET__846d34ee__"